import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const TermsAndConditionsRider = () => {
  return (
    <section className="min-h-screen w-screen bg-gradient-to-b from-[#fefef8] to-[#fafae0] flex flex-col items-center Poppins">
      <Navbar />

      <div className="pt-[60px] w-full flex justify-center px-6">
        <div className="max-w-7xl w-full bg-white shadow-lg rounded-2xl border border-yellow-300 p-6 lg:p-10">
          {/* Title */}
          <h1 className="text-3xl lg:text-4xl font-extrabold text-gray-800 text-center mb-6 tracking-wide">
            Terms and Conditions
          </h1>
          <p className="text-center text-gray-500 mb-8">
            Last updated: <span className="font-medium">July 2026</span>
          </p>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            <p>
              Welcome to Instaport! The following terms and conditions of use,
              together with our Privacy Policy, govern Instaport Delivery
              Service's relationship with you in relation to this app/website
              and the Services. By continuing to browse and use our app/website,
              you agree to comply with and be bound by them.
            </p>

            <p>
              In the event of any conflict between these terms and any other
              executed document, these terms shall take precedence.
            </p>

            {/* ACCEPTANCE OF USERS */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Acceptance of User(s)
              </h2>
              <p>
                Any person, company, or organization authorized to conduct
                business in India is referred to as the "User(s)" and may use
                Instaport services. Users must be legally capable of entering
                enforceable transactions and at least 18 years old. Users must
                follow all applicable laws. Instaport reserves the right to
                refuse service at its sole discretion.
              </p>
            </div>

            {/* Rearranging User Agreement */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Modifications to User Agreement
              </h2>
              <p>
                Instaport may change, modify, amend, or update this agreement
                at any time without prior notice. Updated terms take effect
                immediately upon publication. Continuing to use our services
                constitutes acceptance of the updated terms.
              </p>
            </div>

            {/* AGREEMENT WITH USERS */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Agreement with User(s)
              </h2>
              <p>
                This agreement applies to visitors, free users, registered
                users, and any legal entity represented. Users may only use
                the website for internal or personal use. Additional terms for
                specific services take precedence over these general terms.
              </p>
            </div>

            {/* Defining Terms */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Defining Terms
              </h2>
              <p>The following terms apply:</p>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  <b>INSTAPORT DELIVERY SERVICE:</b> Staff members and
                  service providers responsible for shipments or related services.
                </li>
                <li>
                  <b>"You/Your/Shipment":</b> refers to the sender, recipient,
                  consignee, or any party with legitimate interest in the shipment.
                </li>
                <li>
                  <b>Delivery:</b> Presenting the package to the recipient or
                  notifying them of its arrival.
                </li>
                <li>
                  <b>Restricted Items:</b> Products prohibited by applicable law.
                </li>
                <li>
                  <b>Consignee/Receiver:</b> The shipment's recipient.
                </li>
                <li>
                  <b>Applicable Law:</b> All laws, regulations, guidelines,
                  policies, orders, and similar governmental rules in India.
                </li>
                <li>
                  <b>Dangerous Goods:</b> Products deemed dangerous by ICAO,
                  IATA, IMDG, ADR, or other national transportation laws.
                </li>
                <li>
                  <b>Shipment:</b> Any package or item provided to Instaport for
                  transportation under a Shipment Note.
                </li>
              </ul>
            </div>

            {/* Service Usage Terms & Conditions */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Service Usage Terms & Conditions
              </h2>
              <p>
                Users must pay all applicable fares, fees, and surcharges to
                use Instaport services. Use of services is at the user's risk.
                The company disclaims all warranties. Users agree not to:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Damage or dirty the vehicle.</li>
                <li>Abuse or contaminate technical or non-technical equipment.</li>
                <li>
                  Ask drivers to violate traffic, RTO, or government rules.
                </li>
                <li>Overload the vehicle (up to 20kg for bikes).</li>
              </ul>
              <p>
                Users agree to hold Instaport harmless from any liability, losses,
                legal fees, claims, or expenses arising from use of services.
              </p>
              <p>
                Location data may be used solely to locate the customer. Instaport
                may share information as required by law. Vehicle reservations may
                be canceled at Instaport's discretion. Lost shipments are handled
                on a best-effort basis, and Instaport may exercise a lien until full
                payment is made.
              </p>
              <p>
                Complaints must be reported within 24 hours. Users must comply with
                updated terms posted on our website. Calls may be recorded for quality
                and training purposes.
              </p>
            </div>

            {/* Intellectual Property */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Rights to Intellectual Property
              </h2>
              <p>
                All rights to the website and content belong to Instaport Delivery
                or its licensors. This includes layout, text, images, audio, and
                other content. Content is provided "AS IS" with no warranties.
                Use of trademarks, logos, or icons without authorization is prohibited.
              </p>
            </div>

            {/* Termination */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Termination
              </h2>
              <p>
                Instaport may discontinue access to any part of the website at any
                time, for any reason, without notice. Instaport may restrict,
                refuse, or grant access differently to various users.
              </p>
            </div>

            {/* User Duties */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                User Duties
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  Provide accurate consignment description, documents, and
                  declarations.
                </li>
                <li>
                  Ensure shipments do not contain prohibited items or violate laws.
                </li>
                <li>
                  Obtain insurance for consignments valued above INR 20,000.
                </li>
                <li>
                  Accept that services are at user’s risk, especially for
                  valuables.
                </li>
                <li>
                  Comply with applicable law and indemnify Instaport for losses.
                </li>
                <li>
                  Understand that Force Majeure events may affect services:
                  natural disasters, war, strikes, epidemics, mechanical failures,
                  or third-party actions.
                </li>
              </ul>
            </div>

            {/* Dangerous Goods / Security */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Dangerous Goods / Security
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  Illegal items are not accepted. Users must declare consignment type
                  and value accurately.
                </li>
                <li>
                  Instaport does not handle dangerous goods unless approved in writing.
                </li>
                <li>
                  Instaport reserves the right to inspect shipments for security.
                </li>
                <li>
                  Users accept liability for improper or undeclared items.
                </li>
              </ul>
            </div>

            {/* Liability and Indemnity */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Liability and Indemnity
              </h2>
              <p>
                Instaport is not liable for indirect, incidental, or consequential
                losses arising from use of the service. Users agree to indemnify,
                defend, and hold harmless Instaport, its affiliates, employees,
                and agents from any claims, damages, liabilities, costs, or
                expenses arising from use or misuse of the service.
              </p>
            </div>

            {/* Governing Law */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Governing Law
              </h2>
              <p>
                These terms are governed by the laws of India. Any disputes arising
                in connection with these terms shall be subject to the exclusive
                jurisdiction of Indian courts.
              </p>
            </div>

            {/* Contact Us */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Contact Us
              </h2>
              <p>
                If you have any questions about these Terms and Conditions, please
                contact us at:{" "}
                <Link to="/contact" className="text-yellow-500 font-medium">
                  Contact Page
                </Link>
                .
              </p>
            </div>

            {/* Closing Note */}
            <p className="text-gray-500 text-sm text-center mt-8">
              By using Instaport services, you acknowledge that you have read,
              understood, and agree to these Terms and Conditions.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default TermsAndConditionsRider;

